var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"riskhub-logo",attrs:{"src":require('@/assets/images/riskhub-logo-v3-no-text.svg')},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }